import type { IControlSettingUI } from '~/presentation/reports/common/type';

import {
  GENERAL_FILTER_INFO,
  FILTER_SETTING_UI,
} from '~/presentation/reports/common/ReportFilter/constants/report-filters';
import { createOperatorFilter } from '~/presentation/reports/common/ReportFilter/utils/FilterUI';
import { EControlType, EReportControlId, ERFilterKey } from '~/presentation/reports/common/type';
import { CONTROL_FILTER_INFO, ORDER_FILTER_GROUP } from '../constants';
import { VISITOR_OPTIONS } from '~/modules/report-analytic';
import { THUMB_REPORT_FILTER } from '~/constants/thumbnail';

const ORDER_FILTER_SETTING_UI: Record<string, IControlSettingUI> = {
  ...FILTER_SETTING_UI,
  ...createOperatorFilter(
    {
      id: ERFilterKey.VISITOR,
      label: 'Customer type',
      operatorId: EReportControlId.VISITOR_OPERATOR,
      singleValueId: EReportControlId.VISITOR,
      multiValueId: EReportControlId.VISITORS,
      options: VISITOR_OPTIONS,
    },
    CONTROL_FILTER_INFO,
  ),
};

export const ORDER_CONTROL_SETTING_UI: IControlSettingUI[] = [
  {
    id: EReportControlId.FILTER,
    type: EControlType.SECTION_CARD,
    label: 'Filter',
    config: {
      optionsGroup: ORDER_FILTER_GROUP,
      itemInfo: CONTROL_FILTER_INFO,
      generalItemInfo: GENERAL_FILTER_INFO,
      controlSettingUI: ORDER_FILTER_SETTING_UI,
      defaultControls: [ORDER_FILTER_SETTING_UI[ERFilterKey.DATE]],
      thumbnail: THUMB_REPORT_FILTER,
      searchPlaceholder: 'Search filter',
    },
    controls: [ORDER_FILTER_SETTING_UI[ERFilterKey.DATE]],
  },
];
